import React from "react";

const FavHeartSvg = () => {
  return (
    <span>
      <svg
        class="heart-layer-first"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 28 24"
        fill="#F25D49"
      >
        <g id="card/property/heart/empty" opacity="1">
          <path
            class="heart-layer-second"
            d="M14 22C14 22 2 16.9734 2 8.32493C2 4.8814 4.86628 2 8.58933 2C11.8045 2 13.8776 5.18815 14 5.33006C14.1234 5.18815 16.1998 2 19.4759 2C23.1989 2 26 4.8814 26 8.32493C26 17.4749 14 22 14 22Z"
            fill="#F25D49"
            stroke="#F25D49"
            stroke-width="2.4"
          ></path>
        </g>
      </svg>
    </span>
  );
};

export default FavHeartSvg;
